// Groups every room on file by state, with the city and state hubs that cover it.
// Used by the all-poker-rooms page and its prerender. Names come from the search index only.
var CasinoSearchArray = require('./casino-search-array');
var METRO_HUBS = require('./metro-hubs');
var STATE_HUBS = require('./state-hubs');

var stateByRoom = {};
(CasinoSearchArray || []).forEach(function(item) {
  var raw = String(item || '');
  var at = raw.lastIndexOf(': ');
  if (at < 0) return;
  stateByRoom[raw.slice(0, at)] = raw.slice(at + 2);
});

// Rooms missing from the search index (no poker flag) still sit on a state hub; use that state.
var STATE_BY_ABBR = { TX: 'Texas', CA: 'California', FL: 'Florida', WA: 'Washington' };
Object.keys(STATE_HUBS).forEach(function(slug) {
  (STATE_HUBS[slug].rooms || []).forEach(function(room) {
    if (!stateByRoom[room.name] && STATE_BY_ABBR[room.state]) {
      stateByRoom[room.name] = STATE_BY_ABBR[room.state];
    }
  });
});

function stateSlug(state) {
  return state.toLowerCase().replace(/[^a-z]+/g, '-') + '-poker-rooms';
}

function build(roomNames) {
  var groups = {};
  roomNames.forEach(function(name) {
    var state = stateByRoom[name] || 'Other';
    if (!groups[state]) groups[state] = { state: state, rooms: [], hubs: [] };
    groups[state].rooms.push(name);
  });
  Object.keys(groups).forEach(function(state) {
    var g = groups[state];
    if (STATE_HUBS[stateSlug(state)]) {
      g.stateHub = { to: '/' + stateSlug(state), label: state + ' poker rooms' };
    }
  });
  Object.keys(METRO_HUBS).forEach(function(slug) {
    var hub = METRO_HUBS[slug];
    var first = hub.rooms && hub.rooms[0] && hub.rooms[0].name;
    var state = first && stateByRoom[first];
    if (state && groups[state]) {
      groups[state].hubs.push({ to: '/' + slug, label: hub.shortLabel || hub.footerLabel });
    }
  });
  return Object.keys(groups).sort().map(function(state) {
    groups[state].rooms.sort(function(a, b) {
      return a.toLowerCase().localeCompare(b.toLowerCase());
    });
    return groups[state];
  });
}

module.exports = {
  path: 'all-poker-rooms',
  title: 'All Poker Rooms by State and City | Daily Tourneys',
  description: 'Every U.S. poker room and casino card room on Daily Tourneys, grouped by state, with links to each city hub, room page, and the poker tournament guides.',
  h1: 'All poker rooms by state and city',
  lead: 'Every poker room on file, grouped by state, with links to the city hubs. Open a room for contact details, hours, and any daily or weekly tournament schedule on file.',
  build: build
};



// WEBPACK FOOTER //
// ./js/rooms-index.js